import { useSelector } from 'react-redux';

import { ResourceString } from '@/reducers/common/commonTypes';
import { selectResources } from '@/reducers/common/selectors';

const useResourcesData = () => {
  const resources = useSelector(selectResources) as ResourceString;

  return {
    signupWithGoogleHeading: resources['Signupoptions.googleButton'] ?? 'Sign up with Google',
    signupWithFacebookHeading: resources['Signupoptions.facebookButton'] ?? 'Sign up with Facebook',
    signupWithApple: 'Signup with Apple',
    signupCreateAccount: resources['SignUpOptions.createAccount'] ?? 'Or do it the slow way',
    signupButton: resources['SignUpForm.signUpButton'] ?? 'Sign up with Email',
    firstNameHeading: resources['SignUpForm.firstname'] ?? 'First name',
    lastnameHeading: resources['SignUpForm.lastname'] ?? 'Last name',
    preferredNameHeading: resources['SignUpForm.preferredname'] ?? 'Preferred name',
    emailHeading: resources['SignUpForm.email'] ?? 'Email',
    passwordHeading: resources['SignUpForm.password'] ?? 'Password',
    passwordMessage:
      resources['SignUpForm.passwordMessage'] ??
      'Minimum 8 characters with a mixture of letters (one capital), numbers and symbols (1 special)',
    dobHeading: resources['SignUpForm.dob'] ?? 'Date of birth',
    virginVoyagesNews: resources['SignUpForm.virginVoyagesNews'] ?? 'Virgin Voyages news',
    newsMessage:
      resources['SignUpForm.newsMessage'] ??
      'Fun, ship puns and exclusive travel news are all yours with a simple check of the box. (Our privacy policy means your details stay safe.)',
    emailSubscription: resources['TermsAndConditions.newsletterLabel'] ?? 'Yes, please! I want your lovely emails',
    signupWithEmail: resources['Signupoptions.signUpWithEmail'] ?? 'Sign up with Email',
    incorrectPassword:
      resources['SignIn.incorrectPassword'] ??
      "Looks like you've entered an incorrect email address and/or password (we get it, there are too many to remember these days). Please try again.",
    termsAndPrivacy: resources['SignupEmail.termsAndPrivacy'] ?? 'By Continuing, you are accepting our',
    termsOfService: resources['SignUpEmail.termsOfService'] ?? 'Terms of Service',
    termsAndConditionsLink: resources['EnvVar.TermsAndConditions.Link'] ?? '/addl-terms-and-conditions',
    privacyPolicy: resources['SignUpEmail.privacyPolicy'] ?? 'privacy policy',
    privacyPolicyLink: resources['Book.PrivacyPolicy.URL'] ?? '/privacy-notice',
    signInMessage: resources['SignUpOptions.signInMessage'] ?? 'Already have an account?',
    signIn: resources['SignUpOptions.signIn'] ?? 'Sign in',
    UserExist: resources['SignUpEmail.USER_ALREADY_EXIST'] ?? 'E-mail already registered',
    invalidTLDs: resources['SailorForm.InvalidTLD'] ?? 'con,ron,von,vom,comp,cdom,gom,cpm,comm,cokm',
    virginGroupHeading: resources['VirginGroup.optIn.heading'] ?? 'Wider Virgin family',
    virginGroupDescription:
      resources['VirginGroup.optIn.description'] ??
      'Virgin Red also brings you news, views and special offers from other Virgin companies',
    virginGroupCheckbox:
      resources['VirginGroup.optIn.checkbox'] ??
      'Yes, I’d love to hear about all things Virgin, and agree to Virgin Voyages sharing data about me with Virgin Red so that I get a more personalized experience.',
    virginGroupPrivacyPolicy:
      resources['VirginGroup.optIn.privacyPolicy'] ?? 'https://www.virgin.com/virgin-red/privacy-policy',
    virginGroupDataHandling:
      resources['VirginGroup.optIn.dataHandling'] ?? 'https://www.virgin.com/how-is-my-data-used',
    virginGroupOptOutDetails:
      resources['VirginGroup.optOut.details'] ??
      'You can opt out anytime in My Account under Communication Preferences.',
    virginGroupAsset: resources['VirginGroup.asset'] ?? { src: null, alt: '' },
  };
};

export default useResourcesData;
